module.exports = __webpack_public_path__ + "img/datacenter6.ffb8697e.png";